import type { ComponentPropsWithoutRef } from 'react'

type ButtonProps =
  | (ComponentPropsWithoutRef<'button'> & { href?: never; loading?: string | false })
  | (ComponentPropsWithoutRef<'a'> & { href: string })

export function Button(props: ButtonProps) {
  const className = `cai-button ${props.className ?? ''}`
  if (typeof props.href === 'string') return <a {...props} className={className} />
  const { loading, children, disabled, ...buttonProps } = props
  return (
    <button
      type="button"
      {...buttonProps}
      className={className}
      disabled={disabled || Boolean(loading)}
      aria-busy={loading ? true : undefined}
    >
      {loading ? (
        <span className="button-loading" role="status">
          <span className="loading-spinner" aria-hidden="true" />
          {loading}
        </span>
      ) : (
        children
      )}
    </button>
  )
}
